import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import Popup from 'reactjs-popup';

const AddGuardianPopup = ({ onGuardianAdded }) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [org, setOrg] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState(false);

    const resetFields = () => {
        setFirstName("");
        setLastName("");
        setOrg("");
        setEmail("");
        setPhone("");
        setError(false);
    };

    const handleSave = (close) => {
        if (!firstName.trim()) {
            setError(true);
            return;
        }
        const newGuardian = {
            id: uuidv4(),
            visitor_first_name: firstName.charAt(0).toUpperCase() + firstName.slice(1),
            visitor_last_name: lastName.charAt(0).toUpperCase() + lastName.slice(1),
            visitor_org_name: org.charAt(0).toUpperCase() + org.slice(1),
            visitor_is_minor: false,
            user_is_guardian: false,
            user_is_inviter: false,
            person_is_guardian: true,
            visitor_email: email,
            visitor_phone: phone,
            guardian_first_name: "",
            guardian_last_name: "",
            guardian_email: "",
            guardian_phone: "",
            createdAt: new Date(),
            deadLine: new Date(),
            completed: false,
        };
        onGuardianAdded(newGuardian);
        resetFields();
        close();
    };

    return (
        <Popup
            trigger={<button type="button" className="button save" style={{ marginTop: '8px' }}>+ Add New Guardian</button>}
            className="popup-content__add-guardian"
            modal
            nested
        >
            {close => (
                <div className="floatBody">
                    <div className="floatSignupForm">
                        <form action="" className="floatForm" style={{ minHeight: '300px' }}>
                            <div className="float-header">New Guardian</div>

                            <div className="float-main">
                                {error && (
                                    <p style={{ color: 'red', fontSize: '13px', marginBottom: '8px' }}>
                                        First name is required.
                                    </p>
                                )}

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="gFirstName"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                    <label htmlFor="gFirstName" className="floatLabel">First Name:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="gLastName"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                    <label htmlFor="gLastName" className="floatLabel">Last Name:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="gOrg"
                                        value={org}
                                        onChange={(e) => setOrg(e.target.value)}
                                    />
                                    <label htmlFor="gOrg" className="floatLabel">Organization: <span style={{ fontWeight: 400, fontSize: '12px' }}>(optional)</span></label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="gEmail"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <label htmlFor="gEmail" className="floatLabel">Email:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="gPhone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                    <label htmlFor="gPhone" className="floatLabel">Phone:</label>
                                </div>
                            </div>

                            <div className="float-footer">
                                <div className="formButtons">
                                    <button className="button save" type="button" onClick={() => handleSave(close)}>Save</button>
                                    <button className="button cancel" type="button" onClick={() => { resetFields(); close(); }}>Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default AddGuardianPopup;
